import React from 'react';

const PrinterOptions = (props) => {
    return (
        props.printers.map((printer, i) => <option key={i} value={printer.name}>{printer.name}</option>)
    )
}

export default PrinterOptions;


// WEBPACK FOOTER //
// ./src/components/Common/PrinterOptions/PrinterOptions.js